"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var theme_1 = require("../../theme");
var Spinner_1 = require("../Spinner");
var Typography_1 = require("../Typography");
var ListCardItem_1 = require("./ListCardItem");
var ListCard = function (_a) {
    var title = _a.title, titleClassName = _a.titleClassName, containerClassName = _a.containerClassName, dataTestId = _a["data-testid"], items = _a.items, isLoading = _a.isLoading;
    var bgColors = (0, theme_1.useBackgroundColors)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-testid": dataTestId, className: (0, classnames_1.default)('squid-flex squid-flex-col squid-rounded-component-card-border-radius-base', bgColors.base, containerClassName) }, { children: [!!title && ((0, jsx_runtime_1.jsx)(Typography_1.Display, __assign({ as: "h4", size: "sm", color: "base", className: (0, classnames_1.default)('squid-mb-6', titleClassName) }, { children: title }))), !!isLoading && (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { color: "primary", size: "3xl" }), !isLoading &&
                items.map(function (item, index) { return ((0, jsx_runtime_1.jsx)(ListCardItem_1.default, __assign({}, item, { hasSeparator: index < items.length - 1 }), item.id)); })] })));
};
exports.ListCard = ListCard;
